$(function () {
    function updateModalPosition () {
        var modal = $('#bid-requirements-modal');

        modal.css('margin-top', (modal.outerHeight() / 2) * -1);

        return this;
    };

    // console.log('trigger step-shown-step-wizard');
    // $('.step-wizard').trigger('step-shown-step-wizard');

    $('.step-wizard').on('show-next-step-wizard', function () {
        var $currentStep = $(this).find('.step-wizard-step.active');
        var $nextStep = $currentStep.next();

        $currentStep.removeClass('active').addClass('complete');
        $($currentStep.data('target')).removeClass('active');

        if ($nextStep.hasClass('step-wizard-step')) {
            $nextStep.removeClass('disabled').addClass('active');
            $($nextStep.data('target')).addClass('active');
            updateModalPosition();
            $(this).trigger('step-shown-step-wizard');
        }
    });

    // tmp function
    // $('.step-wizard-next-step-button').on('click', function () {
    //     $(this).parents('.step-wizard').trigger('show.next.step-wizard');
    // });
});
